import axios from "axios";
import {API} from "../config";

const path = "/servico-acolhimento";
const subPath = "/cumprimento-pena";

class PessoaEmCumprimentoSAService {
  novoPessoaEmCumprimentoSA(id, pessoaEmCumprimentoSA){
    let formData = new FormData();

    for ( let key in pessoaEmCumprimentoSA ) {
      formData.append(key, pessoaEmCumprimentoSA[key]);
    }
    return axios.post(API + path + `/${id}` + subPath, formData);
  }

  getPessoasEmCumprimentosSA(id){
    return axios.get(API + path + `/${id}` + subPath)
  }

  atualizarPessoaEmCumprimentoSA(id, idSA, pessoaEmCumprimentoSA){
    let formData = new FormData();

    for ( let key in pessoaEmCumprimentoSA ) {
      formData.append(key, pessoaEmCumprimentoSA[key]);
    }
    return axios.put(API + path + `/${idSA}` + subPath + `/${id}`, formData);
  }

  getPessoaEmCumprimento(id, idSA){
    return axios.get(API + path + `/${idSA}` + subPath + `/${id}`)
  }

  desligarPessoasEmCumprimentoSA(id, idSA, dataDesligamento){
    return axios.post(API + path + `/${idSA}` + subPath + `/desligar/${id}`, {
      dataDesligamento
    });
  }
}
const instancePessoaEmCumprimentoSA = new PessoaEmCumprimentoSAService();
export default instancePessoaEmCumprimentoSA;
